import React from 'react';
import s from '../CreationOfDesign.module.css';
import NewInfoCheckbox from '../../MyOrders/MyOrdersPopups/InfoCheckBox/NewInfoCheckbox';
import {useTranslation} from 'react-i18next';
import {useFormikContext} from 'formik';

type Props = {
	onTypeChange?: (type: 'wholesale' | 'retail') => void;
};

const ClientTypeCheckButtons: React.FC<Props> = ({onTypeChange}) => {
	const {t} = useTranslation();
	const {values, setFieldValue} = useFormikContext();

	const handleTypeChange = (type: 'wholesale' | 'retail') => {
		setFieldValue('typeOrder', type);
		if (onTypeChange) {
			onTypeChange(type);
		}
	};

	return (
		<div className={s.flex}>
			<NewInfoCheckbox
				id={'wholesale'}
				values={values}
				setFieldValue={setFieldValue}
				valueName={'typeOrder'}
				labelTxt={t('Опт')}
				insideOnChange={() => handleTypeChange('wholesale')}
			/>
			<NewInfoCheckbox
				id={'retail'}
				values={values}
				setFieldValue={setFieldValue}
				valueName={'typeOrder'}
				labelTxt={t('Роздріб')}
				insideOnChange={() => handleTypeChange('retail')}
			/>
		</div>
	);
};

export default ClientTypeCheckButtons;
